export default __webpack_public_path__ + "static/media/section3-pic3.0277186a.png";